export enum SettingsPanelMenuList {
	CreditPrices = 'Credit Prices',
	EmailTemplates = 'Email Templates',
	ChangePersonalData = 'Change Personal Data',
	UserAccess = 'User Access',
}
